import { ark } from "@ark-ui/react/factory"
import { styled } from "styled-system/jsx"

export const Root = styled(ark.dialog, {
  base: {
    width: "[770px]",
    rounded: true,
  },
})

const Header = styled(ark.div, {
  base: {
    borderBottom: true,
    padding: "md",
    textStyle: "sectionTitle",
    fontSize: "18px",
  },
})
const Body = styled(ark.div, {
  base: {
    paddingX: "md",
    paddingY: "sm",
  },
})
const Footer = styled(ark.div, {
  base: {
    borderTop: true,
    padding: "md",
  },
})

export const Modal = {
  Root,
  Header,
  Body,
  Footer,
}
